import { NAVY, NAVY_D, GOLD } from '@/lib/colors';
import { crossAppHref } from '@/lib/nav';

export function FinalCTA({ title, sub, btn }: { title: string; sub?: string; btn: string }) {
  return (
    <section
      style={{
        padding: '70px 24px',
        background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_D} 100%)`,
        color: '#fff',
        textAlign: 'center',
      }}>
      <h2
        style={{
          fontFamily: 'Prompt',
          fontSize: 'clamp(24px, 4vw, 36px)',
          fontWeight: 700,
          marginBottom: sub ? 14 : 24,
        }}>
        {title}
      </h2>
      {sub && (
        <p
          style={{
            fontSize: 15,
            color: 'rgba(255,255,255,0.75)',
            maxWidth: 540,
            margin: '0 auto 28px',
            lineHeight: 1.6,
          }}>
          {sub}
        </p>
      )}
      <a
        href={crossAppHref('/signup')}
        style={{
          background: GOLD,
          color: '#fff',
          padding: '14px 36px',
          borderRadius: 8,
          fontFamily: 'Sarabun',
          fontSize: 15,
          fontWeight: 600,
          textDecoration: 'none',
          boxShadow: '0 10px 30px rgba(240,165,0,0.4)',
        }}>
        {btn}
      </a>
    </section>
  );
}
